/* tslint:disable */ /* eslint-disable */
import * as Types from '../../../models/generated/index';

import { gql } from '@apollo/client';
import { SkinnyThemeFragmentFragmentDoc } from '../../../models/generated/SkinnyThemeFragment';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetCustomSurveyQueryVariables = Types.Exact<{
  surveyId: Types.Scalars['Int'];
}>;


export type GetCustomSurveyQuery = { survey: { id: number, name: string, description?: string | undefined, lastUsedAt?: string | undefined, nextUsedAt?: string | undefined, questions: Array<{ id: number, name: string, choices: Array<{ id: number, name: string }>, theme?: { id: number, name: string, color: string, icon: string } | undefined }> } };


export const GetCustomSurveyDocument = gql`
    query GetCustomSurvey($surveyId: Int!) {
  survey(id: $surveyId) {
    id
    name
    description
    lastUsedAt
    nextUsedAt
    questions {
      id
      name
      choices {
        id
        name
      }
      theme {
        ...SkinnyThemeFragment
      }
    }
  }
}
    ${SkinnyThemeFragmentFragmentDoc}`;

/**
 * __useGetCustomSurveyQuery__
 *
 * To run a query within a React component, call `useGetCustomSurveyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomSurveyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomSurveyQuery({
 *   variables: {
 *      surveyId: // value for 'surveyId'
 *   },
 * });
 */
export function useGetCustomSurveyQuery(baseOptions: Apollo.QueryHookOptions<GetCustomSurveyQuery, GetCustomSurveyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomSurveyQuery, GetCustomSurveyQueryVariables>(GetCustomSurveyDocument, options);
      }
export function useGetCustomSurveyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomSurveyQuery, GetCustomSurveyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomSurveyQuery, GetCustomSurveyQueryVariables>(GetCustomSurveyDocument, options);
        }
export type GetCustomSurveyQueryHookResult = ReturnType<typeof useGetCustomSurveyQuery>;
export type GetCustomSurveyLazyQueryHookResult = ReturnType<typeof useGetCustomSurveyLazyQuery>;
export type GetCustomSurveyQueryResult = Apollo.QueryResult<GetCustomSurveyQuery, GetCustomSurveyQueryVariables>;